import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import ServiceForm from './ServiceForm';
import { ServiceApi } from '../../api/adminApi';
import './ServicesAdmin.css';

const ServicesAdmin = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [currentService, setCurrentService] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const loadServices = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await ServiceApi.getAll();
      setServices(data);
    } catch (err) {
      setError(err.message || 'Unable to load services');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadServices();
  }, []);

  const handleCreate = () => {
    setCurrentService(null);
    setIsFormOpen(true);
  };

  const handleEdit = (service) => {
    setCurrentService(service);
    setIsFormOpen(true);
  };

  const handleDelete = async (service) => {
    const confirmed = window.confirm(`Delete service "${service.name}"?`);
    if (!confirmed) return;
    try {
      await ServiceApi.remove(service.id);
      await loadServices();
    } catch (err) {
      setError(err.message || 'Unable to delete service');
    }
  };

  const handleSubmit = async (payload) => {
    setIsSaving(true);
    try {
      if (currentService) {
        await ServiceApi.update(currentService.id, payload);
      } else {
        await ServiceApi.create(payload);
      }
      await loadServices();
      closeForm();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Unable to save service');
    } finally {
      setIsSaving(false);
    }
  };

  const closeForm = () => {
    setIsFormOpen(false);
    setCurrentService(null);
  };

  const handleCancel = () => {
    closeForm();
  };

  return (
    <AdminLayout
      title="Services"
      description="Manage all service pages and their detailed content."
      actions={!isFormOpen && (
        <button className="admin-primary-btn" onClick={handleCreate}>+ Add Service</button>
      )}
    >
      {error && <div className="admin-alert">{error}</div>}

      {isFormOpen ? (
        <ServiceForm
          initialData={currentService}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isSaving={isSaving}
        />
      ) : (
        <div className="services-table-wrapper">
          {loading ? (
            <p>Loading services...</p>
          ) : (
            <table className="services-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Alias</th>
                  <th>Order</th>
                  <th>Icon</th>
                  <th>Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {services.length === 0 && (
                  <tr>
                    <td colSpan="6">No services yet.</td>
                  </tr>
                )}
                {services.map((service) => (
                  <tr key={service.id}>
                    <td>{service.name}</td>
                    <td>{service.alias}</td>
                    <td>{typeof service.sortOrder === 'number' ? service.sortOrder : 0}</td>
                    <td>{service.service_icon ? 'Yes' : '—'}</td>
                    <td>{service.updatedAt ? new Date(service.updatedAt).toLocaleString() : '-'}</td>
                    <td>
                      <div className="table-actions">
                        <button onClick={() => handleEdit(service)}>Edit</button>
                        <button className="danger" onClick={() => handleDelete(service)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </AdminLayout>
  );
};

export default ServicesAdmin;
